import React from "react";
import { Link } from "react-router-dom";
import "../App.css"; // 👈 IMPORTANT

const Footer = () => {
  return (
    <footer
      className="footer-section"
      style={{
        backgroundImage: `url('/assets/images/Rectangle 14.png')`,
      }}
    >
      {/* 1. LOGO & ADDRESS */}
      <div className="footer-logo">
        <h4>Radha Nikunj Bihari Industries</h4>
        <p>145 SG Enclave Majitha road Amritsar 143001</p>
      </div>

      {/* 2. LINKS */}
      <ul className="footer-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/our-shop">Our Shop</Link></li>
        <li><Link to="/contact-us">Contact Us</Link></li>
        <li><Link to="/terms">Terms & Conditions</Link></li>
        <li><Link to="/privacy">Privacy Policy</Link></li>
      </ul>

      {/* 3. SOCIAL ICONS */}
      <div className="social-icons">
        <a href="https://www.instagram.com/divinedepot/" target="_blank" rel="noreferrer">
          <img src="/assets/images/insta.png" alt="instagram" />
        </a>
        <a href="https://wa.me/916283013500" target="_blank" rel="noreferrer">
          <img src="/assets/images/whatsapp.png" alt="whatsapp" />
        </a>
        <a href="https://www.facebook.com/share/1ANKRCDgPw/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
          <img src="/assets/images/facebook.png" alt="facebook" />
        </a>
      </div>

      {/* 4. INFO SECTION */}
      <div className="info">
        <div className="info-block">
          <p>ESTIMATED DELIVERY BETWEEN :- 7–10 Days</p>
          <p>Email Id: info@divinedepot.in</p>
        </div>

        <div className="info-block center">
          <p>
            Copyright © Divine Depot <br />
            Developed by{" "}
            <a href="https://golokait.com/" target="_blank" rel="noreferrer">
              Goloka IT
            </a>
          </p>
        </div>

        <div className="info-block">
          <p>Call between 9am – 6pm</p>
          <p>Phone Number: +91-6283013500</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
